export default __webpack_public_path__ + "static/media/logoTypescript.ba30d176.png";